import React, { useEffect } from 'react';
import {
  CContainer,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardHeader,
  CBreadcrumb,
  CBreadcrumbItem,
} from '@coreui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import ShipmentStatusInputs from '../../components/ShipmentStatusInputs/ShipmentStatusInputs';
import { connect } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import {
  updateShipmentStatusRequestAction,
} from '../../store/shipmentStatus/shipmentStatusActions';

const UpdateShipmentStatus = ({ updateShipmentStatusRequest, isLoading,
   updateShipmentStatusData }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { t } = useTranslation();

  const shipmentStatusData = location.state?.shipmentStatus || null;

  useEffect(() => {
    if (!shipmentStatusData && id) {
      console.warn('Shipment data not found in route. You may want to fetch it by ID:', id);
    }
  }, [shipmentStatusData, id]);

  const handleShipmentSubmit = (shipmentStatusData) => {
    updateShipmentStatusRequest({
      data: shipmentStatusData,
      navigate: navigate,
    });
  };

  const handleBackToShipments = () => {
    navigate('/shipment-status');
  };

  return (
    <div>
      <CContainer>
        <CBreadcrumb className="mb-4">
          <CBreadcrumbItem
            href="#/shipment-status"
            onClick={(e) => {
              e.preventDefault();
              handleBackToShipments();
            }}
          >
            {t('Shipment Status')}
          </CBreadcrumbItem>
          <CBreadcrumbItem active>{t('updateShipmentStatus')}</CBreadcrumbItem>
        </CBreadcrumb>

        <CRow>
          <CCol xs={12}>
            <CCard>
              <CCardHeader>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="mb-0">{t('updateShipmentStatus')}</h4>
                  {shipmentStatusData?.ShipmentStatusId && (
                    <small className="text-muted">
                      {t('Status ID')}: {shipmentStatusData.ShipmentStatusId}
                    </small>
                  )}
                </div>
              </CCardHeader>
              <CCardBody>
                {shipmentStatusData ? (
                  <ShipmentStatusInputs
                    onSubmit={handleShipmentSubmit}
                    onCancel={handleBackToShipments}
                    isLoading={isLoading}
                    submitResponse={updateShipmentStatusData}
                    initialData={shipmentStatusData}
                    isEdit={true}
                  />
                ) : (
                  <div className="text-center py-4">
                    <div className="text-muted">
                      {t('No shipment status data found. Please go back to the list.')}
                    </div>
                    <button
                      className="btn btn-primary mt-3"
                      onClick={handleBackToShipments}
                    >
                      {t('Back to Shipments')}
                    </button>
                  </div>
                )}
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer?.isLoading || false,
  updateShipmentStatusData: state.shipmentStatusReducer?.updateShipmentStatusData || null,
});

const mapDispatchToProps = (dispatch) => ({
  updateShipmentStatusRequest: (payload) =>
    dispatch(updateShipmentStatusRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateShipmentStatus);
